import React from "react";

const CoreValues = ({ values, title }) => {
  return (
    <section className=" text-white py-0 px-8 md:px-16 ">
      <div className="container mx-auto text-center">
        {title && (
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12">
            {title}
          </h2>
        )}

        <div className="flex flex-row flex-wrap gap-8 mx-auto  w-[100%] sm:w-[100%] justify-center items-center ">
          {values.map((theme, index) => (
            <div
              key={index}
              className=" mainContainer h-[192px] w-[100%] sm:h-[320px] sm:w-[320px]  flex flex-col items-center justify-center place-self-center"
            >
              <div className=" theCard sm:py-[40px] sm:px-[24px] h-[192px] w-[100%] sm:h-[320px] sm:w-[320px] ">
                <div className=" shadow-[0_0_20px_4px_rgba(255,255,255,0.8)]  theFront bg-white h-[192px] w-[100%] sm:h-[320px] sm:w-[320px] justify-self-center  text-black p-8 rounded-xl  flex flex-col  justify-center space-y-4">
                  Front
                </div>
                <div className=" shadow-[0_0_20px_4px_rgba(255,255,255,0.8)]  theBack bg-white h-[192px] w-[100%] sm:h-[320px] sm:w-[320px] justify-self-center text-black p-8 rounded-xl  flex flex-col items-center justify-center space-y-4">
                  <div className="flex flex-col gap-[10px] justify-center items-center">
                    <div className="">
                      <img
                        src={theme.icon}
                        alt="Image Not Found"
                        className="w-[60px] h-[60px] lg:w-[90px] lg:h-[90px]"
                      />
                    </div>
                    <div className="font-['Urbanist'] font-bold text-[20px] lg:text-[35px] leading-[100%] tracking-[0%] text-center">
                      {theme.title}
                    </div>

                    <div className="font-urbanist font-light text-[14px] lg:text-[20px]  text-[#0D0E15] leading-[15px] sm:leading-[25px] tracking-[0%] text-center">
                      {theme.description}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
